module.exports = __webpack_public_path__ + "assets/img/ca79ee5f0f30ecb6772d26c76953e6ec.png";